export default __webpack_public_path__ + "static/media/rally.519ad592.mp4";